<template>
    <div>
        <div :class="preCls + 'content-box'">
            <div
                :class="preCls + 'filter'"
                style="display: flex; align-items: center; margin-bottom: 20px"
            >
                <form-lookup
                    style="min-width: 262px; margin-right: 15px"
                    v-model="selectRoom.roomId"
                    :options.sync="selectRoom.roomList"
                    placeholder="房源名称"
                    title="选择房间"
                    textSymbol="title"
                    valueSymbol="id"
                    :modalHeight="600"
                    :modalWidth="900"
                    @change="onSelectRoom"
                    @clear="onClearRoom"
                    @deselect="onDeselectRoom"
                >
                    <select-room />
                </form-lookup>
                <filter-date-range
                    :startDate.sync="filter.startDate"
                    :endDate.sync="filter.endDate"
                    @on-change="search"
                ></filter-date-range>
            </div>
            <table-tool-bar>
                <template slot="left">
                    <table-searcher
                        v-model="filter.cusName"
                        placeholder="请输入客户姓名,手机号或单位名称"
                        style="margin-left: 10px"
                        @search="search"
                    ></table-searcher>
                </template>
                <Button
                    v-if="$can('add')"
                    :class="preCls + 'button-margin'"
                    :disabled="loading"
                    type="primary"
                    @click="onClickAdd"
                >
                    开收据
                </Button>
                <Button
                    v-if="$can('view')"
                    :class="preCls + 'button-margin'"
                    :disabled="loading"
                    @click="onClickExport"
                >
                    导出Excel
                </Button>
            </table-tool-bar>
            <Table
                ref="mt"
                :columns="columns"
                :data="page.list"
                :loading="loading"
                :height="mtHeight"
            >
                <!-- 操作列 -->
                <template v-slot:action="{ row }">
                    <Button
                        v-if="$can('view')"
                        type="default"
                        size="small"
                        style="margin-right: 5px"
                        @click="rowClickView(row)"
                    >
                        详情
                    </Button>
                </template>
            </Table>
            <div class="card-bottom">
                <table-pager
                    :total="page.total"
                    :pageSize.sync="page.pageSize"
                    :pageNo.sync="page.pageNo"
                    @change="fetch"
                >
                </table-pager>
            </div>
        </div>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showReceiptForm"
            :title="actionTitle + '收据'"
            :width="1000"
            :height="664"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <r-receipt-form
                v-if="modal.showReceiptForm"
                :id="curId"
                :actionType="actionType"
            />
        </smart-modal>
    </div>
</template>
<script>
import { mapCache } from '@/plugins/vux-data-cache'
import { ymdL, currency } from '_u/helper'

import mList from '_v/common/m-list'
import SelectRoom from '_vc/select-room'
import RReceiptForm from './r-receipt-form'
import FilterDateRange from '_v/components/filter/filter-date-range'

import { fReceiptList } from '@/api/receipt'

export default {
    name: 'r-receipt-list',
    mixins: [mList],
    components: {
        SelectRoom,
        RReceiptForm,
        FilterDateRange,
    },
    data() {
        return {
            page: {
                total: 0,
                list: [],
            },
            loading: false,
            mtHeight: 360,

            actionType: '', // 1 新增; 2 查看; 3 修改;
            curId: '',
            modal: {
                showReceiptForm: false,
            },
            dict: {
                payType: this.$dict.NULL,
                feeType: this.$dict.NULL,
                actionType: this.$dict.NULL,
            },
        }
    },
    computed: {
        ...mapCache({
            selectRoom: 'receiptIndexSelectRoom',
            filter: 'receiptIndex',
        }),
        columns() {
            return [
                {
                    type: 'index',
                    width: 80,
                    title: '序号',
                    align: 'center',
                },
                {
                    title: '收据编号',
                    key: 'receiptNo',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    title: '客户名称',
                    key: 'cusName',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    title: '手机号',
                    key: 'cusMobile',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: 'comName',
                    title: '单位名称',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    title: '房源名称',
                    key: 'houseName',
                    align: 'left',
                    minWidth: 180,
                    tooltip: true,
                },
                {
                    title: '房间代码',
                    key: 'houseNo',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    title: '账期',
                    key: 'periodCn',
                    align: 'center',
                    minWidth: 230,
                },
                {
                    title: '合计金额(元)',
                    key: 'totalAmount',
                    align: 'right',
                    minWidth: 120,
                },
                {
                    title: '实收金额(元)',
                    key: 'amount',
                    align: 'right',
                    minWidth: 120,
                },
                {
                    title: '收款人',
                    key: 'payee',
                    align: 'left',
                    minWidth: 120,
                },
                {
                    title: '开收据时间',
                    key: 'invoiceTime',
                    align: 'center',
                    minWidth: 150,
                },

                {
                    title: '操作',
                    align: 'center',
                    width: 120,
                    slot: 'action',
                    fixed: 'right',
                },
            ]
        },

        actionTitle() {
            return this.dict.actionType.val(this.actionType)
        },
    },
    watch: {},
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
    created() {
        this.fetch()
    },
    methods: {
        fetch() {
            this.loading = true

            Promise.all([
                fReceiptList(this.filter),
                this.$dict.get(['bill_status', 'action_type']),
            ])
                .then((args) => {
                    var [view, group] = args

                    Object.assign(this.dict, group)

                    this.setPageData(view.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        search() {
            this.filter.pageNo = 1
            this.fetch()
        },
        setPageData(data) {
            data.page.list.forEach((v) => {
                v.invoiceTime = ymdL(v.invoiceTime)
                v.totalAmount = currency(v.totalAmount / 100)
                v.amount = currency(v.amount / 100)
            })
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },
        // 详情
        rowClickView(row) {
            this.actionType = '2'
            this.curId = row.id
            this.modal.showReceiptForm = true
        },

        // 新增
        onClickAdd() {
            this.actionType = '1'
            this.curId = ''
            this.modal.showReceiptForm = true
        },
        // 导出Excel
        onClickExport() {
            this.$refs.mt.exportToExcel()
        },
    },
}
</script>
